<form [formGroup]="deviceForm" novalidate>

  <div class="container-fluid" *ngIf='readOnly'>
    <div class="d-flex flex-row table-responsive no-border">

      <div class="flex-fill pe-3">
        <table formArrayName="submissionChannelForm" class="table table-inner table-condensed">
          <tbody>
            <tr>
              <th>Applicable Submission Channel</th>
            </tr>
            <tr formGroupName="{{i}}" *ngFor="let sizeGroup of submissionChannelForm.controls; let i = index">
              <td [ngClass]="isDefault('Applicable Submission Channel')">
                <label controlName="channel"></label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex-fill pe-3">
        <table class="table table-inner table-condensed">
          <tbody>
            <tr>
              <th>Company Model Tracking Number </th>
            </tr>
            <tr>
              <td [ngClass]="isDefault('Company Model Tracking Number')">
                <label controlName="trackingNumber"></label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="flex-fill">
        <table class="table table-inner table-condensed">
          <tbody>
            <tr>
              <th>Company Model Batch Number </th>
            </tr>
            <tr>
              <td [ngClass]="isDefault('Company Model Batch Number')">
                <label controlName="batchNumber"></label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</form>
